define('gigaset_contentbridge/components/faq',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"gigaset_contentbridge/classes/utils",
	"text!shoptheme/templates/magnific-popup/default.html",
	"magnific-popup"
], function(
	$,
	_,
	Component,
	$$,
	PopupHtml
) {
	var popupTemplate = null;

	return Component.create({
		$init: function() {
			$$.toggle_element(".giga_toggle",".giga_to_toggle");
			//$('<div id="giga_dialog_wrapper" class="giga_dialog"/>').appendTo($("body"));
			this.show_faq(".giga_show_content","#giga_faq_dialog",".giga_rating_uri",
				"#rating_stars","#giga_dialog_wrapper");

			if ($("#giga_product_search").length>0) {
				//$$.product_search("#giga_product_search",$$._products,'faqs_',"#giga_dialog_wrapper");
				this.product_categories_menu(".giga_product_category");
				this.product_categories_menu(".giga_product_subcategory");
				//$$.redirect_to_product("faqs_");
			}
		},

		show_faq: function(elems, dialog, rating_uri, rating_stars_id, appendTo) {
			var self = this,
				showFAQLinks = $(elems);

			//$dialog.dialog({'autoOpen':false,'modal':true,
			//	'appendTo':appendTo,
			//	'dialogClass':'giga_dialog',
			//	'width':$dialog.attr('data-width'),
			//	'show':'slow','hide':'fast'});
			/* $elems.click(function(ev){
				var target = $(ev.currentTarget);
				var click_uri = $(".giga_faq_click",target.parent()).text();
				$.post(click_uri,{},function(){});
				$dialog.dialog("option","title",target.text());


				var content=$(".giga_faq_content",target.parent()).clone();
				$dialog.empty().append(content);

				var phpPath=$(rating_uri,target.parent()).text();
				$(".giga_faq_rating", $dialog).jRating({
					'bigStarsPath':'/typo3conf/ext/giga_util/Resources/Public/Icons/stars.png',
					'smallStarsPath':'/typo3conf/ext/giga_util/Resources/Public/Icons/small.png',
					'phpPath':phpPath,
					'length':rating_stars,
					'rateMax':rating_stars,
					'canRateAgain':true,
					'step':true
				});

				$dialog.dialog('open');
				return false;
			}); */

			showFAQLinks.on('click', function(e) {
				e.preventDefault();
				var link = $(this),
					faqContent = link.next();

				$.magnificPopup.open({
					items: {
						src: self._renderPopup({
							body: faqContent.html()
						}),
						type: 'inline'
					},
					callbacks: {
						open: function() {
							$('.giga_left', this.contentContainer).hide();

							$('a.giga_print', this.contentContainer).on('click', function(e) {
								e.preventDefault();
								window.print();
							});
						}
					}
				});
			});

		},
		product_categories_menu: function(elems) {
			var $elems=$(elems);

			$elems.each(function(idx,elem){
				var $elem=$(elem);
				$elem.hover(function(ev) {
					var parent=$elem.parent();
					var sub=$(ev.currentTarget).children(".giga_menu").first();
					sub.show();
					sub.width(parent.width());
					sub.position({of:parent,my:"left top",at:"left bottom"});
				},function(ev) {
					var sub=$(ev.currentTarget).children(".giga_menu").first();
					sub.hide();
				});
			});
		},
		_renderPopup: function(data) {
			if (null === popupTemplate) {
				popupTemplate = _.template(PopupHtml);
			}

			return popupTemplate(data);
		}
	});
});
